import { RichEmptyState, useTranslation } from '@ukpostbox/frontend-framework';
import React from 'react';
import { MailBoxImage } from '../../Images/MailboxImage';
import { NoMailEmptyStateType } from './EmptyStatesTypes';

function NoMailSearchResultsEmptyState(props: NoMailEmptyStateType) {
	const { t } = useTranslation();

	return (
		<RichEmptyState
			title={t('mailboxes.noResults.title', { folder: props.mailBoxInfo.folderName })}
			description={t('mailboxes.noResults.description')}
			media={<MailBoxImage />}
		/>
	);
}

export { NoMailSearchResultsEmptyState };
